import { Minimap } from './Minimap';
import { FloorIndicator } from './FloorIndicator';
import { InterfaceShortcuts } from './InterfaceShortcuts';
import './TopRightHud.scss';

export const TopRightHud = () => {
  return (
    <div className="top-right-hud">
      <Minimap />
      <FloorIndicator />
      <InterfaceShortcuts />
    </div>
  );
};
